import { ENDPOINTS } from '../constants/endpoints'
import type { AxiosResponse } from 'axios'
import axiosInstance from '@/integrations/axios/axios-instance'

export interface BackupAuditLog {
  _id: string
  action: string
  entity: string
  entityId: string
  userId: string | null
  details: {
    fileName?: string
    timestamp?: string
    [key: string]: unknown
  }
  timestamp: string
}

export interface BackupFileStatus {
  id: string
  name: string
  trashed: boolean
  createdTime: string
  available: boolean
}

export interface BackupStatus {
  lastSuccess: BackupAuditLog | null
  lastFailure: BackupAuditLog | null
}

export const backupApi = {
  getLogs: (): Promise<AxiosResponse<{ logs: Array<BackupAuditLog> }>> => {
    const endpoint = ENDPOINTS.GET_LOGS
    return axiosInstance.get(endpoint)
  },
  triggerBackup: (): Promise<AxiosResponse<{ success: boolean }>> => {
    const endpoint = ENDPOINTS.TRIGGER_BACKUP
    return axiosInstance.post(endpoint)
  },
  getBackupStatus: (): Promise<AxiosResponse<BackupStatus>> => {
    const endpoint = ENDPOINTS.GET_BACKUP_STATUS
    return axiosInstance.get(endpoint)
  },
  getBackupFiles: (): Promise<
    AxiosResponse<{ files: Array<BackupFileStatus> }>
  > => {
    const endpoint = ENDPOINTS.GET_BACKUP_FILES_STATUS
    return axiosInstance.get(endpoint)
  },
  downloadFile: (fileId: string): Promise<AxiosResponse<Blob>> => {
    const endpoint = `${ENDPOINTS.DOWNLOAD_FILE}/${fileId}`
    return axiosInstance.get(endpoint, { responseType: 'blob' })
  },
}
